import { environment } from '../../../../environments/environment';
import { AuctionAsset } from '../index';

export class AssetMapper {
  public static mapItems(
    assets: AuctionAsset[],
    auctionId: string
  ): AuctionAsset[] {
    assets = (assets || []).filter((a) => a.url);
    return assets.map((a) => AssetMapper.mapItem(a, auctionId));
  }
  public static mapItem(asset: AuctionAsset, auctionId: string): AuctionAsset {
    asset.imageUrl = AssetMapper.completeAssetUrl(asset.url, auctionId);
    return asset;
  }
  public static completeAssetUrl(url: string, auctionId: string): string {
    return `${environment.ASSETS_URL}/${auctionId}/${url}`;
  }
}
